export default __webpack_public_path__ + "static/video_kv-a0833000228024b56038702670126412.mp4";